import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.price = {
      flexWrap: 'wrap',
      ml: 2,
      justifyContent: 'flex-end',

      regular: {
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '22px',
        letterSpacing: '0.32px',
        textAlign: 'right',
      },

      strike: {
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '22px',
        letterSpacing: '0.32px',
        textAlign: 'right',
        textDecoration: 'line-through',
        textDecorationThickness: '2px',
        color: 'black',
        ml: 2,
      },
    };
  })()
);
